import { FC } from 'react';
import ReCAPTCHA from 'react-google-recaptcha';
import { Form, Input } from 'antd';

import classes from './index.module.css';

interface CaptchaInputInterface {
	name: string;
	sitekey: string;
	onChange?: (value: any) => void;
	onExpired?: () => void;
	onErrored?: () => void;
}

const CaptchaInput: FC<CaptchaInputInterface> = ({
	name,
	sitekey,
	onChange,
	onExpired,
	onErrored,
}) => {
	return (
		<>
			<Form.Item
				name={name}
				noStyle
				initialValue=""
				rules={[
					{
						required: true,
						message: 'Verifikasi Recaptcha gagal.',
					},
				]}
			>
				<Input className={classes['captcha-field-box']} />
			</Form.Item>
			<Form.Item shouldUpdate>
				{(props) => {
					const { setFieldsValue, validateFields } = props;
					const onChangeCaptcha = (value: any) => {
						setFieldsValue({
							[name]: value,
						});
						if (onChange) onChange(value);
					};
					return (
						<ReCAPTCHA
							sitekey={sitekey}
							onChange={onChangeCaptcha}
							onExpired={() => {
								setFieldsValue({
									[name]: '',
								});

								validateFields();
								if (onExpired) onExpired();
							}}
							onErrored={onErrored}
						/>
					);
				}}
			</Form.Item>
		</>
	);
};

export default CaptchaInput;
